export type NlTheme = 'light' | 'dark'

const STORAGE_KEY = 'nl-theme'

export const useTheme = () => {
  const theme = useState<NlTheme>('nl-theme', () => 'light')

  const apply = (value: NlTheme) => {
    if (!import.meta.client) return
    document.documentElement.setAttribute('data-theme', value)
    try { localStorage.setItem(STORAGE_KEY, value) } catch {}
  }

  const init = () => {
    if (!import.meta.client) return
    let initial: NlTheme = 'light'
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored === 'dark' || stored === 'light') initial = stored
    } catch {}
    theme.value = initial
    apply(initial)
  }

  const toggle = () => {
    const next: NlTheme = theme.value === 'dark' ? 'light' : 'dark'
    theme.value = next
    apply(next)
  }

  const set = (value: NlTheme) => {
    theme.value = value
    apply(value)
  }

  return { theme, init, toggle, set }
}
